import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateUpdatePayload } from 'api/actions/revision-template-update/revision-template-update-payload';
import { RevisionTemplateUpdatePathParameters } from 'api/actions/revision-template-update/revision-template-update-path-parameters';
import { RevisionTemplateUpdateResponse } from 'api/actions/revision-template-update/revision-template-update-response';

type RevisionTemplateUpdateQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateUpdate action.
 */
export const revisionTemplateUpdateActionPath = new SweetPath<keyof RevisionTemplateUpdatePathParameters>(
  '/api/revision-template/update/{revisionTemplateId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateUpdate actions.
 */
export default function createRevisionTemplateUpdateAction(axios: AxiosInstance) {
  return function revisionTemplateUpdateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateUpdatePathParameters;
    query?: RevisionTemplateUpdateQueryParameters;
    payload: RevisionTemplateUpdatePayload;
  }) {
    const path = revisionTemplateUpdateActionPath.insert(parameters);

    return axios.request<RevisionTemplateUpdateResponse, RevisionTemplateUpdateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
